<script setup lang="ts">
import { LEGAL_DOCUMENT_PATHS } from '@falasta/contracts';

import { useCookieConsent } from '../analytics/cookie-consent';

/**
 * Richiesta di consenso ai cookie di misura, come modale a tutta pagina.
 *
 * Le regole non sono grafiche: «Rifiuta» ha lo stesso peso visivo di «Accetta»
 * ed è alla sua sinistra, non c'è una X che valga come consenso, il clic sullo
 * sfondo non decide e non chiude, e finché la scelta non è espressa verso
 * Google non parte nessuna richiesta. Rifiutare libera la pagina esattamente
 * quanto accettare: un banner che rende il rifiuto più faticoso raccoglie
 * consensi non validi, che è peggio di non averne.
 */
const consent = useCookieConsent();
</script>

<template>
  <div
    v-if="consent.asking.value"
    class="cookies"
    role="dialog"
    aria-modal="true"
    aria-label="Consenso ai cookie"
  >
    <div class="cookies__dialog">
      <h2 class="cookies__title">Cookie e misura</h2>
      <p class="cookies__text">
        Questo sito usa cookie tecnici e, <strong>solo se acconsenti</strong>, Google Analytics per
        capire quali pagine vengono lette. Nessuno script di terze parti viene caricato prima della
        tua scelta.
        <a :href="LEGAL_DOCUMENT_PATHS.cookies">Cookie policy</a>
      </p>

      <div class="cookies__actions">
        <button class="button button--ghost" type="button" @click="consent.refuse()">
          Rifiuta
        </button>
        <button class="button" type="button" @click="consent.accept()">Accetta</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cookies {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgb(16 24 40 / 55%);
  backdrop-filter: blur(3px);
}

.cookies__dialog {
  display: grid;
  gap: 1rem;
  width: 100%;
  max-width: 28rem;
  padding: 1.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: var(--color-surface);
  box-shadow: var(--shadow-lg);
}

.cookies__title {
  margin: 0;
  font-size: 1.15rem;
}

.cookies__text {
  margin: 0;
  color: var(--color-muted);
  font-size: 0.875rem;
  line-height: 1.55;
}

.cookies__text a {
  color: var(--color-primary);
}

.cookies__actions {
  display: flex;
  gap: 0.6rem;
}

/* I due pulsanti sono identici anche in larghezza, come la scelta che
   rappresentano. */
.cookies__actions .button {
  flex: 1;
}
</style>
